import React from 'react'
import { useTrans } from 'hooks'
import { CategoriaHelpOnlineNode, PaginaNode } from '@gql/graphql'
import { ArrowLeft } from '@components/icons'
import { Breadcrumbs, Button, JsonLd, SidebarLink, WContainer, WLink } from '@components/atoms'
import { FaqCard, TextBox } from '@components/molecules'
import { Page } from 'components/organisms'
import styles from './CategoriaFaqTemplate.module.sass'
import { removeHTMLTags } from '@utils/index'

interface Props {
  pagina?: PaginaNode
  categoriaFaq?: CategoriaHelpOnlineNode
  categorieFaq?: CategoriaHelpOnlineNode[]
  faqOpened?: string
}

const CategoriaFaqTemplate = (props: Props) => {
  const {
    pagina = undefined,
    categoriaFaq = undefined,
    categorieFaq = [],
    faqOpened = null,
  } = props

  const t = useTrans()

  return (
    <Page pagina={pagina} className={`${styles.root}`}>
      <WContainer>
        <div className={styles.layout}>
          <aside className={styles.sidebar}>
            <SidebarLink
              item={{
                iconLeft: <ArrowLeft />,
                name: t('Tutte le FAQ'),
                url: '/help-online',
              }}
              className={`${styles.back} ${styles['back--desktop']}`}
            />
            {!!categorieFaq?.length && (
              <ul className={styles.nav}>
                {categorieFaq.map((c) => (
                  <li
                    className={`${styles.navItem} ${
                      c.pk === categoriaFaq.pk ? styles['navItem--active'] : ''
                    }`}
                  >
                    <WLink href={c.url}>{c.nome}</WLink>
                  </li>
                ))}
              </ul>
            )}
          </aside>
          <main className={styles.main}>
            <div className={styles.head}>
              <Breadcrumbs breadcrumbs={pagina.breadcrumbs} className={styles.breadcrumbs} />
              <Button
                label={t('Tutte le FAQ')}
                iconLeft={<ArrowLeft />}
                href={'/help-online'}
                variant="ghost"
                className={`${styles.back} ${styles['back--mobile']}`}
              />
              <h1 className={styles.title}>{categoriaFaq?.nome}</h1>
            </div>
            <div className={styles.content}>
              {!!categoriaFaq?.risposte?.length && (
                <div className={styles.list}>
                  {categoriaFaq.risposte.map((f) => (
                    <div className={styles.item}>
                      <FaqCard
                        categoria={categoriaFaq?.nome || ''}
                        faq={f}
                        key={f.pk}
                        isOpen={f.slug === faqOpened}
                      />
                    </div>
                  ))}
                </div>
              )}
              <TextBox
                item={{
                  pk: 1,
                  name: t('Non hai trovato la risposta che cercavi?'),
                  description: t(
                    '<p>Inviaci un messaggio con l’apposito modulo e il nostro team ti risponderà il prima possibile.</p>'
                  ),
                  ctaLabel: t('Contattaci'),
                  url: '/contatti/',
                }}
              />
            </div>
          </main>
        </div>
      </WContainer>
      <JsonLd
        item={categoriaFaq?.risposte?.map((item) => ({
          questionName: item?.nome,
          acceptedAnswerText: removeHTMLTags(item?.risposta),
        }))}
        type="faq"
      />
      <JsonLd type="organization" />
    </Page>
  )
}

export default CategoriaFaqTemplate
